import { createStyles, Theme } from '@material-ui/core'
import {
  colorBlackAlpha05,
  colorBlackAlpha10,
  colorBlackAlpha50,
  colorBlackAlpha70,
  colorGrayNeutralStrong,
  transition,
} from '../../../shared/style-settings'
import { makeStyles } from '@material-ui/core/styles'

export const useAppHeaderSearchStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      background: colorBlackAlpha05,
      height: 37,
      display: 'flex',
      alignItems: 'stretch',
      margin: '0 10px',
      transition: transition,
      borderRadius: 20,

      '&:focus-within': {
        background: colorBlackAlpha10,
      },

      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },

    searchInput: {
      flexGrow: 1,
      border: 'none',
      background: 'none',
      padding: '0 15px',
      color: colorGrayNeutralStrong,
      fontSize: 14,
      outline: 'none',
    },

    searchButton: {
      border: 'none',
      background: 'none',
      color: colorBlackAlpha50,
      padding: '5px 7px 0 7px',
      transition: transition,
      cursor: 'pointer',

      '&:hover': {
        background: colorBlackAlpha10,
        color: colorBlackAlpha70,
      },
    },
  })
)
